import React, { Component } from 'react'
import { HBBModal } from '../../../Modal/Components'
import { EmployeeMovementResponderModalLayout } from '../EmployeeMovementResponderModalLayout'

class EmployeeMovementResponder extends Component {
    constructor() {
        super()
        this.state = {
            isImportEmployeeMovementResponderModalOpened: false,
        }
    }
    openImportEmployeeMovementResponderModal = () => {
        this.setState({ isImportEmployeeMovementResponderModalOpened: true })
    }

    controlOpenCloseOfModal = (status) => {
       this.setState({ isImportEmployeeMovementResponderModalOpened: status })
    }

    refreshOrderList = () => {
        this.props.refreshOrderList()
    }

    render() {
        let modalComponent = null

        if (this.state.isImportEmployeeMovementResponderModalOpened) {
            modalComponent =
                <HBBModal>
                    <EmployeeMovementResponderModalLayout data={this.props.data}
                        closeModal={this.controlOpenCloseOfModal}
                        />
                </HBBModal>
        }
        return (
            <div>
                {modalComponent}
                <button
                    className="btn btn-primary button-custom"
                     onClick={(e) => {
                        e.preventDefault()
                        this.openImportEmployeeMovementResponderModal()
                    }}>
                    Respond
                </button>
            </div>
        )
    }
}

export default EmployeeMovementResponder


// WEBPACK FOOTER //
// ./src/modules/Employees Movement/Components/ActionButtons/EmployeeMovementResponder.js